export const CURRENT_VERSION = HAPYAK_VERSION;

export const VERSION_SUPPORTED = {
    YES: 'yes',
    NO: 'no',
    MAYBE: 'maybe'
}

export const supportedVersion = (version = '0.0.0') => {
    const [major, minor, patch] = version.split('.').map(v => +v),
        [curMajor, curMinor, curPatch] = CURRENT_VERSION.split('.').map(v => +v);

    if (major < curMajor) {
        return VERSION_SUPPORTED.NO;
    }

    if (major === curMajor && minor < curMinor) {
        return VERSION_SUPPORTED.MAYBE;
    }

    return VERSION_SUPPORTED.YES;
}